import { TypeInput, ValidationTextField } from '@bloomays-lib/ui.shared';
import { EU_VAT_REGEX_STRING } from '@bloomays-lib/utils.shared';

export type VATTextFieldProps = {
  name?: string;
  required?: boolean;
  value: string;
  onChange?: (e: { target: { value: string; [key: string]: any } }) => void;
  id?: string;
  hidden?: boolean;
  formElement?: boolean;
};

const VATTextField = (props: VATTextFieldProps) => {
  return (
    <ValidationTextField
      label="Numéro TVA"
      minLength={'2'}
      hidden={props.hidden}
      type={TypeInput.text}
      placeholder="Obligatoire pour les sociétés assujetties à la TVA"
      pattern={EU_VAT_REGEX_STRING}
      formElement={props.formElement}
      {...props}
    />
  ) as React.ReactNode;
};

export default VATTextField;
export { VATTextField };
